import { createContext, useContext, ReactNode } from "react";

type TelegramUser = {
  id: number;
  username: string;
  firstName: string;
};

type TelegramContextType = {
  isTMA: boolean;
  initDataRaw: string | null;
  user: TelegramUser | null;
};

const TelegramContext = createContext<TelegramContextType | undefined>(undefined);

export const useTelegramContext = () => {
  const context = useContext(TelegramContext);
  if (context === undefined) {
    throw new Error("useTelegramContext must be used within a TelegramProvider");
  }
  return context;
};

type TelegramContextProviderProps = {
  children: ReactNode;
  isTMA: boolean;
  initDataRaw: string | null;
  user: TelegramUser | null;
};

export const TelegramContextProvider = ({ children, isTMA, initDataRaw, user }: TelegramContextProviderProps) => {
  return <TelegramContext.Provider value={{ isTMA, initDataRaw, user }}>{children}</TelegramContext.Provider>;
};
